<div *ngIf="loadBreed" class="name">
  <img src="../../../../assets/catinder.svg" alt="head" />
  <br />
  {{ loadBreed.name }}
</div>
<div *ngIf="loadBreed" class="match-description">
  You matched with {{ loadBreed.name }} on 05/02/2020
</div>
<div class="frame">
  <div class="frame-left" *ngIf="loadBreed">
    <p class="from-me">
      Hey love, you look so nice that I start to doubt if words are still able
      to describe yourself?
    </p>
    <p class="from-them">Moi? {{ loadBreed.temperament }} :)</p>
    <p class="from-me">Oh, are you coming from Planet Unreal?</p>
    <p class="from-them">
      Well, maybe you haven't heard of a country named {{ loadBreed.origin }}?
    </p>
  </div>
  <div class="frame-right" *ngIf="loadBreed">
    <p class="from-them">
      You may not believe, but this is what hoomans talk about me: "{{
        loadBreed.description
      }}"
    </p>
    <p class="from-me">
      Love, you make me so curious about your playful soul xo
    </p>
    <p class="from-them">
      Don't mean to brag but hoomans seem really fond of me that they even
      create a
      <a href="{{ loadBreed.wikipedia_url }}" target="_blank">Wikipedia page</a>
      for me...
    </p>
  </div>
</div>
